// Splits a raw keyword string into independent keyword tokens: split on
// commas and newlines, strip a single pair of wrapping quotes, trim, drop
// empties, and dedupe while preserving order. Here it normalizes keyword
// arrays stored on saved dashboards at read time (see
// `normalize-stored-keywords.ts`). Identical copies live in the charts-v2,
// filters search-button, and v1 dashboard features (co-located, not shared,
// per the client import rules); all copies are pinned to one contract by the
// shared cases in `src/test/keyword-split-cases.ts`.
export const parseKeywordInput = (raw: string): string[] => {
  const tokens = raw
    .split(/[,\r\n]/)
    .map((token) => token.trim().replace(/^"|"$/g, '').trim())
    .filter((token) => token.length > 0)

  return Array.from(new Set(tokens))
}
